import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import VoucherDialog from "@/components/site/VoucherDialog";
import { useAuth } from "@/contexts/AuthContext";

const STORAGE_KEY = "oxford_welcome_offer_seen_v1";
const DELAY_MS = 6000;
const EXCLUDED_PATH_PREFIXES = ["/admin", "/login", "/signup", "/profile", "/auth"];

export default function WelcomeOffer() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { user, loading: authLoading } = useAuth();

  useEffect(() => {
    if (EXCLUDED_PATH_PREFIXES.some((p) => pathname.startsWith(p))) return;
    // Never interrupt a signed-in (repeat) customer with the welcome popup.
    if (authLoading || user) return;
    if (typeof window === "undefined") return;
    try {
      if (window.localStorage.getItem(STORAGE_KEY)) return;
    } catch {
      return;
    }
    const id = setTimeout(() => setOpen(true), DELAY_MS);
    return () => clearTimeout(id);
  }, [pathname, user, authLoading]);

  const handleOpenChange = (next) => {
    setOpen(next);
    if (!next) {
      try {
        window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
      } catch {
        /* ignore */
      }
    }
  };

  return (
    <VoucherDialog
      testIdPrefix="welcome-voucher"
      open={open}
      onOpenChange={handleOpenChange}
      showSkipToSchedule
    />
  );
}
